// extracted by mini-css-extract-plugin
export default {"Milestones":"Milestones_Milestones__sfjFE","ProgressValue":"Milestones_ProgressValue__6AO5m","Title":"Milestones_Title__51pT6","Progess":"Milestones_Progess__yDv4W"};